// extracted by mini-css-extract-plugin
export default {"tab":"Cloud_tab__wJY-p"};